export class ClearingHouseBO {
  id: string;
  name: string;
  receiverIDQualifierLid: string;
  receiverIDQualifier_Name: string;
  senderIdQualifier_Name: string;
  receiverId: string;
  senderId: string;
  tradingPartnerId: string;
  senderIDQualifierLid: string;
}
export class ClearingHousePayorMapBO {
  clearingHouseId: string;
  payerId: string;
  isInactive: boolean;
}
export class GetListBase {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "name";
  orderType: string = "asc";
  type: string = "string";
  field: string = "name";
  operator: string = "contains";
  value: string = "";
  matchCase: boolean = false;
  isInactive: boolean;


}

export class columnWidth {
  column: string = "";
  width: number = 0;
}
export class WhereCondition {
  field: string = "name";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
export class ColumnChangeBO {
  id: number;
  column: string;
}

export class functionpermission {
  clearinghousecreate: boolean = true;
  clearinghouseupdate: boolean = true;
  clearinghousedelete: boolean = true;


}